import * as React from "react";
import type { SVGProps } from "react";
const SvgUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 15a1 1 0 1 0-2 0zM3 19H2zm1-4a1 1 0 1 0-2 0zm12.293-6.293a1 1 0 1 0 1.414-1.414zM12 3l.707-.707a1 1 0 0 0-1.414 0zM6.293 7.293a1 1 0 0 0 1.414 1.414zM11 15a1 1 0 1 0 2 0zm9 0v4h2v-4zm0 4a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM19 20H5v2h14zM5 20a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19v-4H2v4zM17.707 7.293l-5-5-1.414 1.414 5 5zm-6.414-5-5 5 1.414 1.414 5-5zM11 3v12h2V3z"
    />
  </svg>
);
export default SvgUpload;
